<template>
  <Card :class="{ 'baseCard': true, 'isDisabled': disabled, 'isChecked': isChecked, 'isClickable': clickable }">
    <div class="cardInner is-flex is-flex-direction-column">
      <label v-if="checkbox || isChecked" class="cardCheckbox">
        <input type="checkbox" :id="trueValue" :value="trueValue" :disabled="disabled || (isChecked && !checkbox)" :checked="isChecked" @change="onChanged" ref="inputEl"  />
        <span :data-icon="checkIcon" />
      </label>
      <header>
        <h5 class="title is-5"><slot name="title" /></h5>
        <p><slot name="subtitle" /></p>
        <hr />
      </header>
      <div class="cardContent is-flex is-align-items-center is-justify-content-center is-flex-direction-column">
        <slot />
      </div>
      <footer>
        <hr />
        <div class="level is-align-items-flex-end is-mobile">
          <div class="level-item level-left is-align-items-flex-end">
            <p class="cardAction"><slot name="action" /></p>
          </div>
          <div class="level-item level-right is-align-items-flex-end">
            <p class="cardAbilities">
              <small><slot name="abilitySmall" /></small>
              <span><slot name="ability" /></span>
            </p>
          </div>
        </div>
      </footer>
    </div>
  </Card>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'

import Card from '@/components/Card'

import cardProps from '@/helpers/cardProps'

export default defineComponent({
  props: {
    ...cardProps
  },

  components: {
    Card
  },

  setup (props, { emit }) {
    const inputEl = ref(null)
    const isChecked = computed(() => props.value && (typeof props.value === 'boolean' || props.value.includes(props.trueValue)))
    const onChanged = (evt) => emit('changed', evt.target.checked)

    return {
      inputEl,
      isChecked,
      onChanged
    }
  }
})
</script>

<style lang="sass">
@import '@/../node_modules/bulma/sass/utilities/derived-variables'

.baseCard
  position: relative
  font-size: 90%
  width: 18rem
  height: 24rem

  @media screen and (max-width: 767px)
    width: 100%
    height: 22rem

  &.isClickable
    cursor: pointer
    box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%), 0 0 0 0.25rem #fff inset, 0 0 0 0.5rem #FFE9C8 inset

  &.isChecked
    box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px var(--primary), 0 0 0 0.5rem #FFE9C8 inset

  &.isDisabled
    color: $text-light
    filter: grayscale(1)
    pointer-events: none
    .title
      color: $text-light
    &.isClickable
      box-shadow: 0 0 0 1px rgb(10 10 10 / 5%), 0 0 0 0.25rem #fff inset, 0 0 0 0.5rem #FFE9C8 inset
    &.isChecked
      box-shadow: 0 0 0 1px var(--primary), 0 0 0 0.5rem #FFE9C8 inset

  hr
    margin: 0.75rem 0
    
  header
    margin-bottom: auto
    .title
      margin-bottom: 0
      font-family: 'Playfair Display', sans-serif

  footer
    margin-top: auto

  .cardInner
    width: 100%
    height: 100%

  .cardContent
    flex: 1
    text-align: center
    line-height: 1.3
    > *
      margin: 0.25rem 0 !important
      
  .cardAction
    font-size: 75%
    font-weight: bold
    font-family: 'Roboto', sans-serif
    text-transform: uppercase
    padding-bottom: 2.5px

  .cardAbilities
    font-family: 'Playfair Display', sans-serif
    text-transform: uppercase
    span,
    small
      display: inline-flex
    small + span
      margin-left: 0.25rem
    span
      font-size: 130%
      font-weight: bold

  .cardCheckbox
    width: 2.5rem
    height: 2.5rem
    position: absolute
    top: 1rem
    right: 1rem
    span
      display: inline-flex
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      background-color: #ffffffcc
      backdrop-filter: blur(1px)
      box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%) inset, 0 0 0 1px rgb(10 10 10 / 5%) inset
      border-radius: 100px
      // transition: all 200ms
      cursor: pointer
    input
      visibility: hidden
      pointer-events: none
      outline: none
      &:checked + span
        opacity: 1
        background-color: var(--primary)
        &::after
          content: attr(data-icon)
          font-family: 'Material Icons'
          display: block
          width: 1em
          height: 1em
          margin: auto
          color: #fff
          vertical-align: middle
          display: inline-flex
          align-items: center
          justify-content: center
          line-height: 1
          font-size: 200%
        &[data-icon='check']::after
          content: '\e5ca'
        &[data-icon='active']::after
          content: '\ea0b'
        &[data-icon='concentrate']::after
          content: '\ea4a'
</style>